module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_2.c9fbca15.png";